module.exports = __webpack_public_path__ + "static/media/07_plantilla_rec_combo_simple_cf_stills_pet_1.5_aq_pera.03e4c159.png";